import LogRocket from "logrocket";
import type { Middleware } from "redux";

import * as actionTypes from "@/redux/actions/actionTypes";
import { getUsernameFromToken, getUserSubType } from "@/utils/authToken";
import { getUserReferralPath } from "@/utils/logRocketUtils";

export const logRocketMiddleware: Middleware = (_store) => (next) => (action) => {
  const result = next(action);

  switch (action.type) {
    /* oxlint-disable stylistic/padding-line-between-statements */
    case actionTypes.AUTH_SUCCESS:
    case actionTypes.LOAD_TOKEN:
    case actionTypes.REFRESH_ACCESS_TOKEN: {
      // Reducer has already written the new token to localStorage by this point
      const username = getUsernameFromToken();

      if (username) LogRocket.identify(username);
      break;
    }
    /* oxlint-enable stylistic/padding-line-between-statements */

    case actionTypes.PROFILE_FETCH_SUCCESS: {
      const { profile } = action;
      const userSubType = getUserSubType(profile);
      const logRocketParams: Record<string, string | undefined> = { UserType: userSubType };

      if (userSubType === "PATIENT") {
        logRocketParams.ReferralPath = getUserReferralPath(profile?.group_type);
      }

      const username = getUsernameFromToken();

      if (username) LogRocket.identify(username, logRocketParams);
      break;
    }
  }

  return result;
};
